// eslint-disable-next-line
import algoliasearch from 'algoliasearch/lite';
import { history as historyRouter } from 'instantsearch.js/es/lib/routers';
import { singleIndex as singleIndexMapping } from 'instantsearch.js/es/lib/stateMappings';
import { indexName } from '../../algolia-shared/config';

/*
    searchParameters
*/
const searchParameters = {
    filters: '',
};

const hitsPerPage = 12;

/*
    routing
*/
const routing = {
    router: historyRouter(),
    stateMapping: singleIndexMapping(indexName),
};

export {
    searchParameters,
    hitsPerPage,
    routing,
};
